import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';
import { FdrCo2Footprint as FdrCo2FootprintType } from '@hotelplan/supergraph-api';
import {
  FdrCo2EmissionItemCaption,
  FdrCo2EmissionItemPercentage,
  FdrCo2EmissionItemWrapper,
  FdrCO2EmissionListWrapper,
  FdrCO2FootprintTitle,
} from './fdr-co2-footprint.styles';

export function FdrCo2Emission({
  accommodationEmissionPercentage,
  flightEmissionPercentage,
  transportEmissionPercentage,
  specialitiesEmissionPercentage,
}: Omit<FdrCo2FootprintType, 'totalEmission'>): ReactElement {
  const [t] = useTranslation('pdp');

  const isBlocks = !!(
    accommodationEmissionPercentage &&
    flightEmissionPercentage &&
    transportEmissionPercentage &&
    specialitiesEmissionPercentage
  );

  return (
    <>
      <FdrCO2FootprintTitle>
        {t('pdp:co2Footprint.emission.title')}
      </FdrCO2FootprintTitle>
      <FdrCO2EmissionListWrapper isBlocks={isBlocks}>
        {flightEmissionPercentage ? (
          <FdrCo2EmissionItem
            percentage={flightEmissionPercentage}
            caption={t('pdp:co2Footprint.emission.flight')}
            iconName="flight-emission"
          />
        ) : null}
        {transportEmissionPercentage ? (
          <FdrCo2EmissionItem
            percentage={transportEmissionPercentage}
            caption={t('pdp:co2Footprint.emission.transport')}
            iconName="transport-emission"
          />
        ) : null}
        {accommodationEmissionPercentage ? (
          <FdrCo2EmissionItem
            percentage={accommodationEmissionPercentage}
            caption={t('pdp:co2Footprint.emission.accommodation')}
            iconName="accommodation-emission"
          />
        ) : null}
        {specialitiesEmissionPercentage ? (
          <FdrCo2EmissionItem
            percentage={specialitiesEmissionPercentage}
            caption={t('pdp:co2Footprint.emission.specialities')}
            iconName="specialities-emission"
          />
        ) : null}
      </FdrCO2EmissionListWrapper>
    </>
  );
}

interface IFdrCo2EmissionItemProps {
  percentage: number;
  caption: string;
  iconName: string;
}

function FdrCo2EmissionItem({
  iconName,
  caption,
  percentage,
}: IFdrCo2EmissionItemProps): ReactElement {
  return (
    <FdrCo2EmissionItemWrapper>
      <FdrCo2EmissionItemPercentage>{`${percentage}%`}</FdrCo2EmissionItemPercentage>
      <BsIcon name={iconName} />
      <FdrCo2EmissionItemCaption>{caption}</FdrCo2EmissionItemCaption>
    </FdrCo2EmissionItemWrapper>
  );
}
